import { BookingApplicationCheckoutState, BookingCheckoutState } from '@shared/types';
import { FunctionComponent, useMemo } from 'react';
import { IconSummary } from '../../IconSummary';
import { CalendarDayLightIcon } from '../../../../Icons';
import { useOccurrence } from '../../../data/useOccurrence';
import { PublicBlendedCourse, PublicClassCourse } from '@cademy-package/sdk-component-types';
import { TimezoneDate } from '../../../../TimezoneDate';

export type BookedDateSummaryProps = {
    course: PublicClassCourse | PublicBlendedCourse;
    checkoutState: BookingCheckoutState | BookingApplicationCheckoutState;
};

export const BookedDateSummary: FunctionComponent<BookedDateSummaryProps> = ({
    course,
    checkoutState,
}) => {
    const occurrence = useOccurrence({
        checkoutState,
        courseId: course._id,
        educatorId: course.educator_ref,
    });

    if (!occurrence) {
        return null;
    }

    return (
        <IconSummary Icon={CalendarDayLightIcon}>
            <div>
                <span>
                    From:{' '}
                    <TimezoneDate
                        date={occurrence.times.start.zoned_datetime}
                        format={{
                            day: 'numeric',
                            month: 'short',
                            hour: 'numeric',
                            minute: 'numeric',
                            timeZoneName: 'short',
                        }}
                    />
                </span>
            </div>
            <div>
                <span>
                    To:{' '}
                    <TimezoneDate
                        date={occurrence.times.end.zoned_datetime}
                        format={{
                            day: 'numeric',
                            month: 'short',
                            hour: 'numeric',
                            minute: 'numeric',
                            timeZoneName: 'short',
                        }}
                    />
                </span>
            </div>
        </IconSummary>
    );
};
